module.exports = __webpack_public_path__ + "assets/img/fd7384d22e348591290ab8bac3f29e34.svg";